import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './index_types.2';

export function getShippingCompanyList(variable?: null, options?: GqlRequestOptions) {
  const query = 'query GetShippingCompanyList { shipping_company_list { code name en_name ja_name } }';
  return gql_request<types.GetShippingCompanyList, null>('GetShippingCompanyList', query, variable, { use_consumer: true, ...options });
}

export function getOrderItemRequestInfo(variable: types.GetOrderItemRequestInfoVariables, options?: GqlRequestOptions) {
  const query = 'query GetOrderItemRequestInfo($order_number: String!, $order_item_request_number: String!) { order(order_number: $order_number) { payment_method } }';
  return gql_request<types.GetOrderItemRequestInfo, types.GetOrderItemRequestInfoVariables>('GetOrderItemRequestInfo', query, variable, { use_consumer: true, ...options });
}
